export default [
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/views/maintenance/index.vue')
  }
]
